import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private snackBar: MatSnackBar) { }

  showSuccessNotification(message: string) {
    this.snackBar.open(message, '', {
      duration: 3000, // Duración de 5 segundos
      panelClass: ['snack-bar-success'],
      verticalPosition: 'top',
      horizontalPosition: 'center',
    });
  }

  showErrorNotification(message: string) {
    this.snackBar.open(message, '', {
      duration: 3000, // Duración de 5 segundos
      panelClass: ['snack-bar-error'],
      verticalPosition: 'top',
      horizontalPosition: 'center',
    });
  }
}
